import React, { useState, useEffect, useRef, useCallback } from "react";
import OlMap from "ol/Map";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON.js";
import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { transform } from "ol/proj";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import LayerSwitcher from "ol-layerswitcher";
import ImageWMS from "ol/source/ImageWMS";
import ImageLayer from "ol/layer/Image";
import {
  ScaleLine,
  FullScreen,
  Rotate,
  defaults as defaultControls,
} from "ol/control";
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from "ol/interaction";
import { Circle as CircleStyle, Fill, Stroke, Style, Icon } from "ol/style";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import Overlay from "ol/Overlay.js";
import "ol/ol.css";
import "reactjs-popup/dist/index.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GeoJSON as GeoJSONFormat } from "ol/format";
import { bbox as bboxStrategy } from "ol/loadingstrategy.js";
import queryString from "query-string";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import axios from "axios";
import Text from "ol/style/Text.js";
import { fromLonLat } from "ol/proj";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import NavigationIcon from "@mui/icons-material/Navigation";
import StarIcon from "@mui/icons-material/Star";
import HistoryIcon from "@mui/icons-material/History";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import Rating from "@mui/material/Rating";
import Fade from "@mui/material/Fade";
import Grow from "@mui/material/Grow";
import { useDispatch, useSelector } from "react-redux";
import { ShareLocation } from "./share-location";
import { ShareRoute } from "./share-route";
import {
  setCurrentLocation,
  closeRoadFetchStart,
} from "../../store/map/reducer";
import { CurrentLocationControl } from "./location";
import {
  setLocationStart,
  setSharedLocationStart,
} from "../../store/direction/reducer";
import * as colors from "@mui/material/colors";

const pickLocationSource = new VectorSource();
const startMarkerSource = new VectorSource();
const endMarkerSource = new VectorSource();

const speedOneSource = new VectorSource();
const speedTwoSource = new VectorSource();
const speedThreeSource = new VectorSource();

const layerSpeedOneSource = new VectorLayer();
const layerSpeedTwoSource = new VectorLayer();
const layerSpeedThreeSource = new VectorLayer();

const styleOne = new Style();

const geoserver_url = "https://ssgi.edas.et/:8080/geoserver/wms";

const NorthArrow = document.createElement("img");
NorthArrow.setAttribute("src", "north-arrow.png");

export const MapWfs = (props) => {

  const dispatch = useDispatch();
  const [pickedLocation, setPickedLocation] = useState();

  const startLocationRef = useRef();
  const mapElement = useRef();
  const [input, setInput] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openRoad, setOpenRoad] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [hoveredFeature, setHoveredFeature] = React.useState(null);
  const [selectedFeature, setSelectedFeature] = React.useState(null);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(0);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [featureHistory, setFeatureHistory] = React.useState([]);
  const [favoriteFeatures, setFavoriteFeatures] = React.useState([]);
  const [copiedText, setCopiedText] = React.useState(false);
  const [featureImages, setFeatureImages] = React.useState({});

  // Helper function to detect feature type
  const getFeatureType = (feature) => {
    const props = feature.values_;
    if (props.name || props.name_eng || props.Building_amh) return 'landmark';
    if (props.prcl_code || props.prcl_uid || props.parcel_uni) return 'parcel_web_v7';
    if (props.road_uid || props.type) return 'road';
    if (props.nh_code) return 'neighbourhood';
    return 'unknown';
  };
  function toggleDetails(btn) {
  const box = btn.nextElementSibling;
  const open = box.style.display === 'block';
  box.style.display = open ? 'none' : 'block';
  btn.textContent = open ? 'Show Details' : 'Hide Details';
}

function copyText(text) {
  if (!text || text === 'N/A') return;
  navigator.clipboard.writeText(text);
  alert('Copied');
}

function navigateTo(lat, lon) {
  if (!lat || !lon) return;
  window.open(
    `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`,
    '_blank'
  );
}

 // Helper function to format popup content based on feature type
const formatPopupContent = (feature) => {
  const props = feature.values_;
  const featureType = getFeatureType(feature);

  let images = '';
  let mainContent = '';
  let detailContent = '';

  /* ---------------- IMAGE HANDLING ---------------- */
  if (featureType === 'landmark') {
    const featureId = getFeatureId(feature);
    const imageUrl = featureImages[featureId];

    if (imageUrl) {
      images = `
        <div style="text-align:center;margin-bottom:12px">
          <img
            src="${imageUrl}"
            alt="${props.name_eng || props.name || 'Landmark'}"
            style="width:100%;max-width:400px;height:200px;
              object-fit:cover;border-radius:12px;
              box-shadow:0 4px 12px rgba(0,0,0,.15)"
            onerror="this.style.display='none'"
          />
        </div>
      `;
    } else {
      images = `
        <div style="text-align:center;margin-bottom:12px">
          <div style="
            height:200px;border-radius:12px;
            background:#eee;display:flex;
            align-items:center;justify-content:center;
            color:#777">
            Loading image...
          </div>
        </div>
      `;
      setTimeout(() => getFeatureImage(feature), 100);
    }
  }

  /* ---------------- SWITCH ---------------- */
  switch (featureType) {

    case 'landmark': {
      const phone =
        props.phone || props.Phone || props.contact_phone || 'N/A';

      const website =
        props.website || props.Website || props.url || '';

     detailContent = `
<div style="font-size:18px;font-weight:600;color:#1976d2;line-height:1.4">
                ${props.name_eng || props.name || ''}
                <span style="font-size:18px;font-weight:600;color:#1976d2;line-height:1.4">
                 ( ${props.legal_name || ''})<br> </span>
                  <span style="font-size:16px;font-weight:600;color:gray;line-height:1.4;display:block;text-align:center">

                  ${props.legal_na_2 || ''}
                  </span>
               
              </div>
      <div style="padding:14px;font-family:Arial;max-width:340px">

          ${images}
          </div>
  <div style="font-size:13px;line-height:1.6">

    <div class="row-item" onclick="copyText('${props.building_u || ''}')">
      <b>🏠 House No:</b>
      <span>${props.building_u || 'N/A'}</span>
    </div>

    <div class="row-item" onclick="copyText('${props.building_l || ''} ${props.building_1 || ''}')">
      <b>📍 Location:</b>
      <span>${props.building_l || ''} ${props.building_1 || ''}</span>
    </div>

    <div class="row-item" onclick="copyText('${props.legal_name || ''}')">
      <b>📝 Name (Amh):</b>
      <span>${props.legal_name || 'N/A'}</span>
    </div>

    <div class="row-item" onclick="copyText('${props.legal_na_2 || ''}')">
      <b>🗣 Name (Local):</b>
      <span>${props.legal_na_2 || 'N/A'}</span>
    </div>

    <div class="row-item">
      <b>📞 Phone:</b>
      ${phone !== 'N/A'
        ? `<span style="color:#1976d2;cursor:pointer"
             onclick="event.stopPropagation();window.location.href='tel:${phone}'">
             ${phone}
           </span>`
        : '<span>N/A</span>'
      }
    </div>

    ${website ? `
      <div class="row-item">
        <b>🌐 Website:</b>
        <span style="color:#1976d2;cursor:pointer"
          onclick="event.stopPropagation();window.open('${website}','_blank')">
          Open Website
        </span>
      </div>
    ` : ''}

   

     

  </div>
`;


      mainContent = `
        <div style="padding:14px;font-family:Arial;max-width:340px">


          
             
              <div style="font-size:14px;color:#666">
                ${props.Building_amh || ''}
              </div>
            </div>
          </div>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">
            <div style="background:#f5f5f5;padding:8px;border-radius:6px">
              <div style="font-size:11px;color:#777">Category</div>
              <b>${props.fun_type || props.category || 'N/A'}</b>
            </div>
            <div style="background:#f5f5f5;padding:8px;border-radius:6px">
              <div style="font-size:11px;color:#777">City</div>
              <b>${props.city_name || props.City_Name || 'N/A'}</b>
            </div>
          </div>

          <div style="margin-top:10px;background:#e3f2fd;
            padding:8px;border-left:4px solid #1976d2;border-radius:6px">
            <div style="font-size:11px;color:#777">Region</div>
            <b style="color:#1976d2">${props.region || 'N/A'}</b>
          </div>

        

          <div class="details" style="display:none;margin-top:12px">
            ${detailContent}
          </div>
        </div>
      `;
      break;
    }

    default:
      mainContent = `<div>No data available</div>`;
  }

  return {  detailContent,mainContent};
};
function copyAllDetails(btn) {
  const container = btn.closest('.details');
  if (!container) return;
  navigator.clipboard.writeText(container.innerText);
  alert('All details copied');
}


  // Interactive sidebar helper functions
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleFeatureSelect = (feature) => {
    setSelectedFeature(feature);
    setSidebarOpen(true);
    
    // Add to history (avoid duplicates)
    const featureId = getFeatureId(feature);
    setFeatureHistory(prev => {
      const filtered = prev.filter(f => getFeatureId(f) !== featureId);
      return [feature, ...filtered].slice(0, 10); // Keep last 10
    });
  };

  const getFeatureId = (feature) => {
    const props = feature.values_;
    return props.prcl_uid || props.Building_UID || props.road_uid || props.nh_code || JSON.stringify(props);
  };

  const toggleFavorite = (feature) => {
    const featureId = getFeatureId(feature);
    setFavoriteFeatures(prev => {
      const exists = prev.some(f => getFeatureId(f) === featureId);
      if (exists) {
        return prev.filter(f => getFeatureId(f) !== featureId);
      } else {
        return [...prev, feature];
      }
    });
  };

  const isFavorite = (feature) => {
    const featureId = getFeatureId(feature);
    return favoriteFeatures.some(f => getFeatureId(f) === featureId);
  };

  const copyFeatureInfo = (feature) => {
    const props = feature.values_;
    const featureType = getFeatureType(feature);
    let text = `${featureType.toUpperCase()} Information:\n`;
    
    if (featureType === 'landmark') {
      text += `Name: ${props.name_eng || props.name || 'N/A'}\n`;
      text += `Category: ${props.fun_type || props.category || 'N/A'}\n`;
      text += `City: ${props.city_name || props.City_Name || 'N/A'}\n`;
      text += `UID: ${props.Building_UID || props.building_u || 'N/A'}`;
    } else if (featureType === 'parcel') {
      text += `Code: ${props.prcl_code || 'N/A'}\n`;
      text += `UID: ${props.prcl_uid || 'N/A'}\n`;
      text += `Unit: ${props.parcel_uni || 'N/A'}\n`;
      text += `Area: ${props.parcel_are || 'N/A'}`;
    }
    
    navigator.clipboard.writeText(text);
    setCopiedText(true);
    setTimeout(() => setCopiedText(false), 2000);
  };

  const shareFeature = (feature) => {
    const props = feature.values_;
    const coordinate = feature.getGeometry().getCoordinates();
    const shareUrl = `${window.location.origin}?lat=${coordinate[1]}&lng=${coordinate[0]}`;
    navigator.clipboard.writeText(shareUrl);
    setCopiedText(true);
    setTimeout(() => setCopiedText(false), 2000);
  };

  const navigateToFeature = (feature) => {
    const coordinate = feature.getGeometry().getCoordinates();
    window.initialMap.getView().animate({
      center: coordinate,
      duration: 1000,
      zoom: 18,
    });
  };

  const filterFeatures = (features) => {
    if (!searchQuery) return features;
    return features.filter(feature => {
      const props = feature.values_;
      const searchLower = searchQuery.toLowerCase();
      return Object.values(props).some(value => 
        value && value.toString().toLowerCase().includes(searchLower)
      );
    });
  };

  // Image fetching functions
  const fetchFeatureImage = async (feature) => {
    const featureId = getFeatureId(feature);
    const props = feature.values_;
    
    // Check if image already exists in state
    if (featureImages[featureId]) {
      return featureImages[featureId];
    }

    try {
      let imageUrl = null;
      
      // Method 1: Check if image URL is directly available in properties
      if (props.image && typeof props.image === 'string') {
        imageUrl = props.image;
      } else if (props.image_url) {
        imageUrl = props.image_url;
      } else if (props.photo) {
        imageUrl = props.photo;
      }
      
      // Method 2: Try to construct image URL from GeoServer
      if (!imageUrl && props.Building_UID) {
        const baseUrl = 'https://ssgi.edas.et/:8080/geoserver/wms';
        imageUrl = `${baseUrl}?service=WMS&version=1.1.0&request=GetMap&layers=geoserver:landmark&format=image/png&width=200&height=200&filter=Building_UID='${props.building_u}'`;
      }
      
      // Method 3: Try to fetch from a generic image service based on landmark type
      if (!imageUrl) {
        const landmarkName = props.name_eng || props.name || '';
        const landmarkType = props.fun_type || props.category || '';
        
        // You can use services like Unsplash, Pexels, or your own image server
        // Example with Unsplash (you'll need to get an API key)
        const searchQuery = encodeURIComponent(`${landmarkName} ${landmarkType}`);
        imageUrl = `https://source.unsplash.com/400x300/?${searchQuery}`;
      }
      
      // Test if image is accessible
      if (imageUrl) {
        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = imageUrl;
        });
        
        // Store successful image URL
        setFeatureImages(prev => ({ ...prev, [featureId]: imageUrl }));
        return imageUrl;
      }
      
    } catch (error) {
      console.warn('Failed to fetch image for feature:', featureId, error);
    }
    
    return null;
  };

  const getFeatureImage = async (feature) => {
    const featureId = getFeatureId(feature);
    
    // Return cached image if available
    if (featureImages[featureId]) {
      return featureImages[featureId];
    }
    
    // Fetch and cache new image
    return await fetchFeatureImage(feature);
  };

  // Enhanced collision detection with clustering
  const adjustTextPosition = (feature, allFeatures, zoom) => {
    const props = feature.values_;
    const geometry = feature.getGeometry();
    const coordinate = geometry.getCoordinates();
    
    // Adjust minimum distance based on zoom level
    const minDistance = Math.max(20, 60 / Math.pow(zoom, 0.5));
    
    // Check for nearby features and adjust position
    let adjustedOffsetY = -25;
    let adjustedOffsetX = 0;
    const usedPositions = new Set();
    
    // Define possible text positions (offsetY, offsetX)
    const positions = [
      [-25, 0],   // top center
      [-40, 0],   // top higher
      [-25, -20], // top left
      [-25, 20],  // top right
      [-10, 0],   // above icon
      [-55, 0],   // very high
      [-25, -35], // far left
      [-25, 35],  // far right
    ];
    
    // Check which positions are occupied by other features
    allFeatures.forEach(otherFeature => {
      if (otherFeature !== feature) {
        const otherGeometry = otherFeature.getGeometry();
        const otherCoordinate = otherGeometry.getCoordinates();
        
        // Calculate distance between features
        const distance = Math.sqrt(
          Math.pow(coordinate[0] - otherCoordinate[0], 2) + 
          Math.pow(coordinate[1] - otherCoordinate[1], 2)
        );
        
        // If too close, mark positions as occupied
        if (distance < minDistance) {
          const hash = Math.abs(otherCoordinate[0] + otherCoordinate[1]) % positions.length;
          usedPositions.add(hash);
        }
      }
    });
    
    // Find first available position
    for (let i = 0; i < positions.length; i++) {
      if (!usedPositions.has(i)) {
        adjustedOffsetY = positions[i][0];
        adjustedOffsetX = positions[i][1];
        break;
      }
    }
    
    return { offsetY: adjustedOffsetY, offsetX: adjustedOffsetX };
  };

  // Custom zoom levels for different landmark types
  const getLandmarkZoomThreshold = (landmarkType) => {
    const type = (landmarkType || '').toLowerCase();
    
    // Very important landmarks - always visible
    if (type.includes('hospital') || type.includes('medical')) return 15;
    if (type.includes('school') || type.includes('education')) return 15;
    if (type.includes('government') || type.includes('office')) return 19;
    
    // Important landmarks - visible at medium zoom
    if (type.includes('restaurant') || type.includes('food')) return 17;
    if (type.includes('hotel') || type.includes('lodging')) return 17;
    if (type.includes('religious') || type.includes('church') || type.includes('mosque')) return 17;
    
    // Regular landmarks - visible at higher zoom
    if (type.includes('shop') || type.includes('store')) return 18;
    if (type.includes('park') || type.includes('recreation')) return 15;
        if (type.includes('bank') || type.includes('financial')) return 20;

    // Default landmarks - visible only at high zoom
    return 20;
  };

  // Check if landmark should be visible based on zoom level and type
  const shouldShowLandmark = (feature, zoom) => {
    const props = feature.values_;
    const landmarkType = props.fun_type || props.category || '';
    
    // Get custom zoom threshold for this landmark type
    const requiredZoom = getLandmarkZoomThreshold(landmarkType);
    
    // Show landmark only if current zoom meets or exceeds threshold
    return zoom >= requiredZoom;
  };

  // Enhanced Smart Clustering System with priority handling
  const clusterLandmarks = (features, zoom) => {
    if (zoom >= 10) return features; // No clustering at high zoom
    
    // Filter features based on zoom thresholds
    const visibleFeatures = features.filter(feature => {
      const props = feature.values_;
      const landmarkType = props.fun_type || props.category || '';
      const requiredZoom = getLandmarkZoomThreshold(landmarkType);
      return zoom >= requiredZoom;
    });
    
    // Dynamic cluster distance based on zoom level
    const clusterDistance = 0.0005 * Math.pow(2, 15 - zoom);
    const clusters = [];
    const processed = new Set();
    
    // Separate priority and non-priority features
    const priorityTypes = ['hospital', 'school', 'government', 'bank', 'restaurant', 'mosque', 'church'];
    const priorityFeatures = visibleFeatures.filter(feature => {
      const props = feature.values_;
      const landmarkType = props.fun_type || props.category || '';
      return priorityTypes.some(type => landmarkType.toLowerCase().includes(type));
    });
    
    const nonPriorityFeatures = visibleFeatures.filter(feature => !priorityFeatures.includes(feature));
    
    // Process all visible features together for clustering
    const allFeatures = [...priorityFeatures, ...nonPriorityFeatures];
    
    allFeatures.forEach((feature, index) => {
      if (processed.has(index)) return;
      
      const geometry = feature.getGeometry();
      const coordinate = geometry.getCoordinates();
      const cluster = [feature];
      processed.add(index);
      
      // Find nearby features for clustering
      allFeatures.forEach((otherFeature, otherIndex) => {
        if (index !== otherIndex && !processed.has(otherIndex)) {
          const otherGeometry = otherFeature.getGeometry();
          const otherCoordinate = otherGeometry.getCoordinates();
          
          const distance = Math.sqrt(
            Math.pow(coordinate[0] - otherCoordinate[0], 2) + 
            Math.pow(coordinate[1] - otherCoordinate[1], 2)
          );
          
          if (distance < clusterDistance) {
            cluster.push(otherFeature);
            processed.add(otherIndex);
          }
        }
      });
      
      clusters.push(cluster);
    });
    
    return clusters;
  };

  // Get cluster center coordinate
  const getClusterCenter = (cluster) => {
    let totalX = 0, totalY = 0;
    cluster.forEach(feature => {
      const coordinate = feature.getGeometry().getCoordinates();
      totalX += coordinate[0];
      totalY += coordinate[1];
    });
    return [totalX / cluster.length, totalY / cluster.length];
  };

  // Get cluster icon based on content
  const getClusterIcon = (cluster) => {
    const priorityTypes = ['hospital', 'school', 'government', 'bank', 'restaurant', 'mosque', 'church'];
    let hasPriority = false;
    let dominantType = '';
    const typeCount = {};
    
    cluster.forEach(feature => {
      const props = feature.values_;
      const landmarkType = props.fun_type || props.category || '';
      typeCount[landmarkType] = (typeCount[landmarkType] || 0) + 1;
      
      if (priorityTypes.some(type => landmarkType.toLowerCase().includes(type))) {
        hasPriority = true;
      }
    });
    
    // Find dominant type
    let maxCount = 0;
    for (const [type, count] of Object.entries(typeCount)) {
      if (count > maxCount) {
        maxCount = count;
        dominantType = type;
      }
    }
    
    return getLandmarkIcon(dominantType);
  };

  // Create zoom level indicator layer
  const createZoomIndicatorLayer = () => {
    const zoomIndicatorSource = new VectorSource();
    
    // Create a feature for the zoom indicator
    const zoomFeature = new Feature({
      name: 'zoom_indicator',
      type: 'zoom_indicator'
    });
    
    // Position the indicator in the top-right corner of the map
    const updateZoomIndicatorPosition = () => {
      if (window.initialMap) {
        const view = window.initialMap.getView();
        const zoom = Math.round(view.getZoom() * 10) / 10; // Round to 1 decimal place
        
        // Get map extent for positioning
        const extent = view.calculateExtent();
        const centerX = (extent[0] + extent[2]) / 2;
        const centerY = (extent[1] + extent[3]) / 2;
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        
        // Position in top-right corner (10% from edges)
        const posX = centerX + (width * 0.35);
        const posY = centerY + (height * 0.4);
        
        zoomFeature.setGeometry(new Point([posX, posY]));
        zoomFeature.set('zoom', zoom);
      }
    };
    
    zoomIndicatorSource.addFeature(zoomFeature);
    
    const zoomIndicatorLayer = new VectorLayer({
      source: zoomIndicatorSource,
      style: function(feature) {
        const zoom = feature.get('zoom') || 0;
        
        return new Style({
          image: new CircleStyle({
            radius: 25,
            fill: new Fill({ color: 'rgba(25, 118, 210, 0.9)' }),
            stroke: new Stroke({ color: '#ffffff', width: 3 }),
          }),
          text: new Text({
            text: `Zoom: ${zoom}`,
            font: 'bold 14px Arial',
            fill: new Fill({ color: '#ffffff' }),
            stroke: new Stroke({ color: 'rgba(25, 118, 210, 0.8)', width: 3 }),
            textAlign: 'center',
            textBaseline: 'middle',
          }),
          zIndex: 9999, // Always on top
        });
      },
    });
    
    return { layer: zoomIndicatorLayer, updatePosition: updateZoomIndicatorPosition };
  };

  // Icon mapping for different landmark types - using actual images from public directory
  const getLandmarkIcon = (funType) => {
    const type = (funType || '').toLowerCase();
    
    // Use actual image files from public directory
    if (type.includes('restaurant') || type.includes('food')) return '/Restaurant.png';
    if (type.includes('hotel') || type.includes('lodging')) return '/Hotel.png';
    if (type.includes('guest_house') || type.includes('guesthouse')) return '/Guest_House.png';
    if (type.includes('resort')) return '/Resort.png';
    if (type.includes('hospital') || type.includes('medical')) return '/Hospital.png';
    if (type.includes('pharmacy')) return '/Pharmacy.png';
    if (type.includes('school') || type.includes('education')) return '/University.png';
    if (type.includes('university')) return '/University.png';
    if (type.includes('bank') || type.includes('financial') || type.includes('atm')) return '/Bank.png';
    if (type.includes('atm')) return '/ATM.png';
    if (type.includes('shop') || type.includes('store') || type.includes('supermarket')) return '/Supermarket.png';
    if (type.includes('supermarket')) return '/Supermarket.png';
    if (type.includes('government') || type.includes('office') || type.includes('police')) return '/Police.png';
    if (type.includes('police')) return '/Police.png';
    if (type.includes('park') || type.includes('recreation')) return '/green.png';
    if (type.includes('religious') || type.includes('church') || type.includes('mosque')) {
      if (type.includes('mosque')) return '/Mosque.png';
      if (type.includes('catholic')) return '/Catholic_Church.png';
      if (type.includes('orthodox')) return '/Orthodox_Church.png';
      if (type.includes('protestant')) return '/Protestant_Church.png';
      return '/Orthodox_Church.png'; // default church
    }
    if (type.includes('fuel') || type.includes('gas') || type.includes('station')) return '/Fuel_Station.png';
    
    // Default landmark icon
    return '/6.png';
  };

  // Preload image when feature is selected
  React.useEffect(() => {
    if (selectedFeature) {
      getFeatureImage(selectedFeature);
    }
  }, [selectedFeature]);

  // Update landmark styles when zoom changes
  React.useEffect(() => {
    if (window.initialMap) {
      const view = window.initialMap.getView();
      
      // Create and add zoom indicator layer
      const { layer: zoomIndicatorLayer, updatePosition: updateZoomPosition } = createZoomIndicatorLayer();
      window.initialMap.addLayer(zoomIndicatorLayer);
      
      // Initial position update
      updateZoomPosition();
      
      const updateStyles = () => {
        // Force style refresh on zoom change for all vector layers
        window.initialMap.getLayers().getArray().forEach(layer => {
          if (layer instanceof VectorLayer) {
            // Check if this layer has landmark features by examining its source
            const source = layer.getSource();
            if (source && source.getFeatures) {
              const features = source.getFeatures();
              // Check if any feature has landmark properties
              const hasLandmarks = features.some(feature => 
                feature.values_.name || feature.values_.name_eng || feature.values_.fun_type
              );
              if (hasLandmarks) {
                layer.changed(); // Trigger style re-evaluation
              }
            }
          }
        });
        
        // Update zoom indicator position and text
        updateZoomPosition();
      };
      
      view.on('change:resolution', updateStyles);
      
      return () => {
        view.un('change:resolution', updateStyles);
        // Clean up zoom indicator layer
        if (window.initialMap) {
          window.initialMap.removeLayer(zoomIndicatorLayer);
        }
      };
    }
  }, []);

  const {
    centerPoint,
    places,
    parcels,
    neighbourhoods,
    buildings,
    roads,
    activePlace,
    nearBy_places,
    closedRoads,
  } = useSelector((state) => state.map);
  const { pathUrls } = useSelector((state) => state.direction);

  useEffect(() => {
    dispatch(closeRoadFetchStart({}));
  }, []);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const handleCloseRoad = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenRoad(false);
  };
  useEffect(() => {
    if (pathUrls.length > 0) {
      if (pathUrls.data == []) {
        setOpenRoad(true);
      }
    }
  }, [pathUrls]);

  useEffect(() => {
    const osm = new TileLayer({
      title: "OSM",
      type: "base",
      visible: false,
      source: new OSM(),
    });

    const noneTile = new TileLayer({
      title: "None",
      type: "base",
      visible: true,
    });

    const mapboxsatelite = new TileLayer({
      source: new XYZ({
        url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      }),
      title: "Satelite",
      visible: false,
      type: "base",
      title: "satilite",
    });

    const mapboxdark = new TileLayer({
      title: "Mapbox Dark",
      type: "base",
      visible: false,
      source: new XYZ({
        url: "http://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2V3dW5ldGFiIiwiYSI6ImNqdHF5dXVjaDAzaTE0M3AyN2lxbHpjaTgifQ.JZCg_-uirI2jMGxO5psDJQ",
      }),
    });

    const baseMaps = new LayerGroup({
      title: "View Options",
      layers: [mapboxsatelite, osm],
    });

    const bishoftuSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:bishoftu_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: "https://ssgi.edas.et/:8080/geoserver/wms?",
    });
    const bishoftuWMS = new ImageLayer({
      // title: "Bishoftu Boundary",
      source: bishoftuSource,
      projection: 'EPSG:4326',
    });

    const ethSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:eth_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const ethWMS = new ImageLayer({
      // title: "Eth Boundary",
      source: ethSource,
      projection: 'EPSG:4326',
    });

    const buildingLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:building_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const buildingWmsLayer = new ImageLayer({
      // title: "Building",
      source: buildingLayerSource,
      projection: 'EPSG:4326',
    });

    const citiesLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:cities_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const citiesWmsLayer = new ImageLayer({
      // title: "Cities",
      source: citiesLayerSource,
      projection: 'EPSG:4326',
    });

    const drivingDirectionLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:driving_direction",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const drivingDirectionWmsLayer = new ImageLayer({
      // title: "Driving Direction",
      source: drivingDirectionLayerSource,
      projection: 'EPSG:4326',
    });

    const ethLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:eth_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const ethWmsLayer = new ImageLayer({
      // title: "Ethio Boundary",
      source: ethLayerSource,
      projection: 'EPSG:4326',
    });

    const landmarklayer = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:landmark",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    var wmsLayer = new ImageLayer({
      // title: "Land marks",
      source: landmarklayer,
      projection: 'EPSG:4326',
    });

    const landUselayer = new ImageWMS({
      crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:lulc_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const wmsLandUseLayer = new ImageLayer({
      // title: "Land Use",
      source: landUselayer,
      projection: 'EPSG:4326',
    });

    const nhLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:nh_aoi_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const nhWmsLayer = new ImageLayer({
      // title: "Neighborhood",
      source: nhLayerSource,
      projection: 'EPSG:4326',
    });

    const paRoadsLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:pa_roads",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const paRoadsWmsLayer = new ImageLayer({
      // title: "pa_roads",
      source: paRoadsLayerSource,
      projection: 'EPSG:4326',
    });

    const parcelLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:parcel_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const parcelWmsLayer = new ImageLayer({
      // title: "Parcel",
      source: parcelLayerSource,
      projection: 'EPSG:4326',
    });
    const roadPolygonprincipalLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_polygon_v7_principal",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadPolygonprincipalWmsLayer = new ImageLayer({
      // title: "Road polygon principal",
      source: roadPolygonprincipalLayerSource,
      projection: 'EPSG:4326',
    });
    const roadPolygonLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_polygon_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadPolygonWmsLayer = new ImageLayer({
      // title: "Road polygon",
      source: roadPolygonLayerSource,
      projection: 'EPSG:4326',
    });






    const roadSignsLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_signs",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadSignsWmsLayer = new ImageLayer({
      // title: "Road Signs",
      source: roadSignsLayerSource,
      projection: 'EPSG:4326',
    });

    const roadRetworkLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_network",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadRetworkWmsLayer = new ImageLayer({
      // title: "Road network",
      source: roadRetworkLayerSource,
      projection: 'EPSG:4326',
    });

    // Enhanced landmark vector layer with icons and labels
    const landmarkSource = new VectorSource({
      url: "https://ssgi.edas.et/:8080/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:landmark&outputFormat=application/json",
      format: new GeoJSON(),
    });
    
    landmarkSource.on('featuresloadstart', () => setLoading(true));
    landmarkSource.on('featuresloadend', () => setLoading(false));
    landmarkSource.on('featuresloaderror', (error) => {
      setLoading(false);
      setError('Failed to load landmark data');
      console.error('Landmark WFS error:', error);
    });

    const vector = new VectorLayer({
      source: landmarkSource,
      projection: 'EPSG:4326',
      style: function(feature) {
        const props = feature.values_;
        const funType = props.fun_type || props.category || '';
        const iconName = getLandmarkIcon(funType);
        const name = props.name_eng || props.name || '';
        
        // Get current zoom level
        const view = window.initialMap?.getView();
        const zoom = view ? view.getZoom() : 10;
        
        // Check if landmark should be visible at current zoom
        if (!shouldShowLandmark(feature, zoom)) {
          return new Style({
            image: new Icon({
              anchor: [0.5, 1],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              src: iconName,
              scale: 0.5, // Even smaller for non-priority landmarks
            }),
            zIndex: 999,
          });
        }
        
        // Get all features for collision detection
        const allFeatures = landmarkSource.getFeatures();
        const adjustedPosition = adjustTextPosition(feature, allFeatures, zoom);
        
        // Apply enhanced clustering at lower zoom levels
        const clusters = clusterLandmarks(allFeatures, zoom);
        const isInCluster = clusters.some(cluster => 
          cluster.length > 1 && cluster.includes(feature)
        );
        
        if (isInCluster && zoom < 14) {
          // Get cluster information
          const cluster = clusters.find(c => c.includes(feature));
          const clusterCount = cluster.length;
          const clusterIcon = getClusterIcon(cluster);
          
          // Enhanced cluster marker with icon overlay
          return new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              src: clusterIcon,
              scale: 0.6,
              opacity: 0.9,
            }),
            text: new Text({
              text: clusterCount.toString(),
              font: 'bold 12px Arial',
              fill: new Fill({ color: '#ffffff' }),
              stroke: new Stroke({ color: '#1976d2', width: 4 }),
              textAlign: 'center',
              textBaseline: 'middle',
              offsetY: -15, // Position number above icon
            }),
            zIndex: 1002,
          });
        }
        
        return new Style({
          image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: iconName,
            scale: 0.8,
          }),
          text: new Text({
            text: name,
            font: 'bold 12px Arial',
            fill: new Fill({ color: '#333333' }),
            stroke: new Stroke({ color: '#ffffff', width: 2 }),
            offsetY: adjustedPosition.offsetY,
            offsetX: adjustedPosition.offsetX,
            textAlign: 'center',
          }),
          zIndex: 1000,
        });
      },
    });

    // Enhanced parcel vector layer with error handling
    const parcelSource = new VectorSource({
      url: "https://ssgi.edas.et/:8080/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:parcel_v7&outputFormat=application/json",
      format: new GeoJSON(),
    });
    
    parcelSource.on('featuresloadstart', () => setLoading(true));
    parcelSource.on('featuresloadend', () => setLoading(false));
    parcelSource.on('featuresloaderror', (error) => {
      setLoading(false);
      setError('Failed to load parcel data');
      console.error('Parcel WFS error:', error);
    });

    const vectorParcel = new VectorLayer({
      source: parcelSource,
      projection: 'EPSG:4326',
      style: new Style({
        stroke: new Stroke({
          color: '#388e3c',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(56, 142, 60, 0.1)',
        }),
      }),
    });

    const featureLayer = new LayerGroup({
      title: "base Map",
      type: "base",   // 👈 important: treat this as a base layer
      layers: [
        ethWmsLayer,
        bishoftuWMS,
        wmsLandUseLayer,
        parcelWmsLayer,
        roadPolygonWmsLayer,
        roadPolygonprincipalWmsLayer,
        buildingWmsLayer,
        nhWmsLayer,
        paRoadsWmsLayer,
        roadRetworkWmsLayer,
        citiesWmsLayer,
        roadSignsWmsLayer,
        drivingDirectionWmsLayer,
        // wmsLayer,
        vectorParcel,
        vector,
      ],
    });


    // const center = [38.97735, 9.74975];
    // const center = [42.12683836966125, 9.306213446378933];

const center = [42.12097080698814, 9.307753784363607];
    window.initialMap = new OlMap({
      target: mapElement.current,
      layers: [baseMaps, featureLayer],
      view: new View({
        center: center,
        zoom: 15,
        projection: "EPSG:4326",
      }),
      controls: defaultControls().extend([
        new ScaleLine(),
        new FullScreen(),
        new CurrentLocationControl(),
        new Rotate({
          autoHide: false,
          label: NorthArrow,
          compassClassName: "north-arrow",
        }),
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
    });

    const layerSwitcher = new LayerSwitcher({
      reverse: true,
      groupSelectStyle: "group",
    });

    window.initialMap.addControl(layerSwitcher);

    // Remove overlay system and use sidebar instead
    // const container = document.getElementById("popup");
    // const content = document.getElementById("popup-content");
    // const closer = document.getElementById("popup-closer");
    // const details = document.getElementById("details");
    // const accordion = document.getElementById("popup-accordion");
    // const emptyFeature = document.getElementById("empty-feature");

    // window.popupOverlay = new Overlay({
    //   element: container,
    //   autoPan: {
    //     animation: {
    //       duration: 250,
    //     },
    //     margin: 50,
    //   },
    //   positioning: 'left-center',
    //   stopEvent: false,
    // });

    // closer.onclick = function () {
    //   window.popupOverlay.setPosition(undefined);
    //   closer.blur();
    //   return false;
    // };
    // Enhanced click handler with sidebar functionality
    window.initialMap.on("singleclick", function (e) {
      const feature = window.initialMap.forEachFeatureAtPixel(
        e.pixel,
        function (feature) {
          return feature;
        }
      );

      if (feature && feature.values_) {
        try {
          handleFeatureSelect(feature);
        } catch (error) {
          console.error('Error displaying feature popup:', error);
          setError('Error displaying feature information');
        }
      } else {
        setSelectedFeature(null);
        setSidebarOpen(false);
      }
    });

    // Add hover functionality for better UX
    window.initialMap.on("pointermove", function (e) {
      const feature = window.initialMap.forEachFeatureAtPixel(
        e.pixel,
        function (feature) {
          return feature;
        }
      );

      if (feature !== hoveredFeature) {
        // Reset previous hovered feature style
        if (hoveredFeature) {
          const featureType = getFeatureType(hoveredFeature);
          
          // Restore original style with text labels for landmarks
          if (featureType === 'landmark') {
            const props = hoveredFeature.values_;
            const funType = props.fun_type || props.category || '';
            const iconName = getLandmarkIcon(funType);
            const name = props.name_eng || props.name || '';
            
            const originalStyle = new Style({
              image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: iconName,
                scale: 0.8,
              }),
              text: new Text({
                text: name,
                font: 'bold 12px Arial',
                fill: new Fill({ color: '#333333' }),
                stroke: new Stroke({ color: '#ffffff', width: 2 }),
                offsetY: -25,
                textAlign: 'center',
              }),
              zIndex: 1000,
            });
            hoveredFeature.setStyle(originalStyle);
          } else {
            // Reset to null to restore default layer style for other features
            hoveredFeature.setStyle(null);
          }
        }

        // Highlight new hovered feature
        if (feature) {
          const featureType = getFeatureType(feature);
          
          if (featureType === 'landmark') {
            // Highlight landmark but keep text and icon
            const props = feature.values_;
            const funType = props.fun_type || props.category || '';
            const iconName = getLandmarkIcon(funType);
            // const name = props.name_eng || props.name || '';
            const name = '';

            
            const highlightStyle = new Style({
              image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: iconName,
                scale: 1.0, // Slightly larger scale for hover
              }),
              text: new Text({
                text: name,
                font: 'bold 14px Arial', // Slightly larger font for hover
          fill: new Fill({ color: '#333333' }),
                stroke: new Stroke({ color: '#ffffff', width: 2 }),
                offsetY: -25,
                textAlign: 'center',
              }),
              zIndex: 1001, // Higher z-index for hovered features
            });
            // feature.setStyle(highlightStyle);
          } else {
            // Original highlight style for other feature types
            const highlightStyle = new Style({
              stroke: new Stroke({ color: '#2e7d32', width: 3 }),
              fill: new Fill({ color: 'rgba(46, 125, 50, 0.3)' }),
            });
            feature.setStyle(highlightStyle);
          }
          
          setHoveredFeature(feature);
          window.initialMap.getTargetElement().style.cursor = 'pointer';
        } else {
          setHoveredFeature(null);
          window.initialMap.getTargetElement().style.cursor = 'default';
        }
      }
    });
  }, []);

  useEffect(() => {
    let num = window.initialMap.getLayers().getLength();
    console.log(num);
    while (num > 2) {
      window.initialMap.getLayers().pop();
      num--;
    }
    props.setPath_datas([]);
    window.popupOverlay = { setPosition: () => {} }; // Mock for compatibility
  }, [props.activeTab]);

  useEffect(() => {
    console.log("kkkk", window.initialMap.getLayers().getLength())
  })

  useEffect(() => {
    // Sidebar functionality replaces popup overlay
    if (parcels.length) {
      const searchPrsels = [];
      parcels.forEach((e) => {
        const feature = new Feature({
          geometry: new Polygon(e.geometry.coordinates[0]),
          name: "Parcel Code " + e.properties.prcl_code,
          Building_amh: "Neigbourhood " + e.properties.neighborho,
          City_Name: "Parcel Unit " + e.properties.parcel_uni,
        });
        searchPrsels.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchPrsels,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 3,
          }),
        }),
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (neighbourhoods.length) {
      const searchedNeighbourhoods = [];
      neighbourhoods.forEach((e) => {
        const feature = new Feature({
          geometry: new Polygon(e.geom.coordinates[0]),
          name: "Neighbourhood Code " + e.nh_code,
        });
        searchedNeighbourhoods.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchedNeighbourhoods,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 3,
          }),
        }),
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (buildings.length) {
      const searchBuildings = [];
      buildings.forEach((e) => {
        const d = e.geometry.coordinates[0][0][0];
        const feature = new Feature({
          geometry: new Point(d),
          name: "Building ID " + e.id,
        });
        searchBuildings.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchBuildings,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "6.png",
          }),
        }),
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (roads.length) {
      const searchRoads = [];
      roads.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new LineString(d),
          name: "Road Id " + e.properties.road_uid,
          Building_amh: e.properties.type,
          City_Name: +e.properties.road_weath,
        });
        searchRoads.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchRoads,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 5,
          }),
        }),
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }


    if (places.length) {
      const searchByName = [];
      places.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new Point(d),
          name: e.properties.name_eng,
          Building_UID: e.properties.building_u,
          Building_L: d,
          Building_N: e.properties.building_n,
          Building_amh: e.properties.legal_name,
          Building_oro: e.properties.legal_na_2,
          category: e.properties.fun_type,
          region: e.properties.region,
          City_Name: e.properties.city_name,
          Parking_Facility: e.properties.parking_fa,
          Village_Na: e.properties.village_na,
          image: e.properties.image,
        });

        feature.setStyle(
          new Style({
            image: new Icon({
              scale: 0.6,
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: centerPoint === e.id ? "green.png" : "blue.png",
            }),
          })
        );

        searchByName.push(feature);
      });
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchByName,
        }),
        projection: 'EPSG:4326'
      });
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });
      window.initialMap.addLayer(vectorLayer);
      if (places.length >= 2) {
        window.initialMap.getView().fit(vectorLayer.getSource().getExtent(), {
          padding: [100, 100, 100, 100],
        });
      }
    }

    if (nearBy_places.length) {
      const searchByName = [];
      nearBy_places.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new Point(d),
          name: e.properties.name_eng,
          Building_UID: e.properties.building_u,
          Building_L: d,
          Building_N: e.properties.building_n,
          Building_amh: e.properties.legal_name,
          Building_oro: e.properties.legal_na_2,
          category: e.properties.function_t,
          region: e.properties.region,
          City_Name: e.properties.city_name,
          Parking_Facility: e.properties.parking_fa,
          Village_Na: e.properties.village_na,
          image: e.properties.image,
        });

        feature.setStyle(
          new Style({
            image: new Icon({
              scale: 0.6,
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: centerPoint === e.id ? "green.png" : "blue.png",
            }),
          })
        );

        searchByName.push(feature);
      });
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchByName,
        }),
        projection: 'EPSG:4326'
      });
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });
      window.initialMap.addLayer(vectorLayer);
      if (places.length >= 2) {
        window.initialMap.getView().fit(vectorLayer.getSource().getExtent(), {
          padding: [100, 100, 100, 100],
        });
      }
    }
  }, [places, neighbourhoods, parcels, buildings, roads, nearBy_places]);

  useEffect(() => {
    var iconFeature = new Feature({
      geometry: new Point(
        transform([8.76038702, 39.00008797], "EPSG:4326", "EPSG:3857")
      ),
      population: 4000,
      rainfall: 500,
    });
    var vectorSource1 = new VectorSource({
      features: [iconFeature],
      style: new Style({
        image: new Icon({
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: "6.png",
        }),
      }),
    });

    var vectorLayer1 = new VectorLayer({
      source: vectorSource1,
      projection: 'EPSG:4326',
    });
    window.initialMap.addLayer(vectorLayer1);
  }, []);

  useEffect(() => {
    console.log("lll", pathUrls)

    if (pathUrls.length != 0) {
      for (let index = 0; index < pathUrls.length; index++) {
        const element = pathUrls[index];
        if (element.data != undefined && element.data.length == 0) {
          setOpenRoad(true);
        }

        if (element.data != undefined)
          props.setPath_datas([...props.path_datas, ...element.data]);
      }
    }

    // drawDirection(pathUrls);
  }, [pathUrls]);
  useEffect(() => {
    window.initialMap.un("singleclick", handleSelectClick);
    pickLocationSource.clear(true);
    setPickedLocation(null);
    if (props.activeTab !== "DIRECTION") {
      window.initialMap.on("singleclick", handleSelectClick);
    }
  }, [props.activeTab]);
  useEffect(() => {
    window.initialMap.un("singleclick", handleDirectionClick);
    startLocationRef.current = null;
    if (props.activeTab === "DIRECTION") {
      window.initialMap.on("singleclick", handleDirectionClick);
    }
  }, [props.activeTab]);
  useEffect(() => {
    if (activePlace) {
      window.initialMap.getView().animate({
        center: activePlace,
        duration: 1000,
        zoom: 20,
      });
    }
  }, [activePlace]);
  useEffect(() => {
    window.initialMap.getLayers().forEach((layer) => {
      if (layer instanceof VectorLayer) {
        window.initialMap.removeLayer(layer);
      }
    });
    window.popupOverlay = { setPosition: () => {} };
  }, [props.activeTab]);
  const handleSelectClick = useCallback((e) => {
    const coordinate = e.coordinate;
    const feature = new Feature({
      geometry: new Point(coordinate),
    });
    pickLocationSource.clear(true);
    pickLocationSource.addFeature(feature);
    const layer = new VectorLayer({
      source: pickLocationSource,
      projection: 'EPSG:4326',
      style: new Style({
        image: new Icon({
          scale: 0.6,
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: "red.png",
        }),
      }),
    });
    window.initialMap.addLayer(layer);
    setPickedLocation(coordinate);
    window.initialMap.getView().animate({
      center: coordinate,
      duration: 750,
    });
  }, []);
  var featureLayer = new LayerGroup({
    layers: [],
    name: "markerGroup",
  });
  useEffect(() => {
    console.log("lll", pathUrls)
    if (pathUrls != undefined) {
      if (props.path_datas.length != 0) {
        console.log("llll", props.path_datas.length)
        var speed = 0;
        var speed1;
        var speed2;
        var speed3;
        var const1 = 0;
        var const2 = 0;
        var const3 = 0;
        var coordinate1x1;
        var coordinate2x2;
        var coordinate3x3;
        var coordinate1y1;
        var coordinate2y2;
        var coordinate3y3;
        if (props.path_datas.length != 0) {
          let num = window.initialMap.getLayers().getLength();
          while (num > 2) {
            window.initialMap.getLayers().pop();
            num--;
          }
          if (props.activeInnerTab == "CAR") {
            speed = 60;
          } else if (props.activeInnerTab == "BIKE") {
            speed = 25;
          } else if (props.activeInnerTab == "WALK") {
            speed = 4;
          }
          var mid = props.path_datas.length / 2;
          mid = mid.toFixed(0);
          coordinate2x2 =
            props.path_datas[props.path_datas.length - 1].geometry
              .coordinates[0][0];
          coordinate2y2 =
            props.path_datas[props.path_datas.length - 1].geometry
              .coordinates[0][1];
          coordinate1x1 = props.path_datas[0].geometry.coordinates[0][0];
          coordinate1y1 = props.path_datas[0].geometry.coordinates[0][1];
          for (let i = 1; i < props.path_datas.length; i++) {
            const element = props.path_datas[i];
            if (element != []) {
              var pathSeq = element.properties.path_id;
              if (pathSeq != "1") {
                const2 += element.properties.cost / 1000;
                speed2 = const2 / speed;

                // convert to minutes (as a number)
                // speed2 = (speed2).toFixed(0);
            speed2 = (speed2 * 60).toFixed(0);

                if (speed2 < 1) {
                  // Convert to seconds if less than 1 minute
                  const seconds = Math.round((const2 / speed) * 60);
                  speed2 = `${seconds} sec`;
                } else if (speed2 >= 60) {
                  const hours = Math.floor(speed2 / 60);       // Whole hours
                  const minutes = Math.round(speed2 % 60);     // Remaining minutes
                  // speed2 = `${hours}h and ${minutes}min`;
                  speed2=""
                } else {
                  // Show in minutes
                  speed2 = `${speed2} min`;
                }

              } else if (pathSeq == "1") {
                const1 += element.properties.cost / 1000;
                speed1 = const2 / speed;
                speed1 = (speed1).toFixed(0);

                if (speed1 < 1) {
                  const seconds = Math.round((const2 / speed) * 60);
                  speed1 = `${seconds} sec`;
                } else if (speed1 >= 60) {
                  const hours = Math.floor(speed1 / 60);
                  const minutes = Math.round(speed1 % 60);
                  speed1 = `${hours}h and ${minutes}min`;
                } else {
                  speed1 = `${speed1} min`;
                }
              }
            }
          }

          if (const2 < 1) {
            const1 = const1 * 1000;
            const1 = Number(const1.toFixed(2)) + "m";
          } else {
            const1 = Number(const1.toFixed(2)) + "km";
          }
          if (const2 < 1) {
            const2 = const2 * 1000;
            const2 = Number(const2.toFixed(2)) + "m";
          } else {
            const2 = Number(const2.toFixed(2)) + "km";
          }
        }
        const length = pathUrls.length - 1;
        startLocationRef.current = null;
        window.initialMap.getLayers().forEach((layer) => {
          if (layer instanceof VectorLayer) {
            window.initialMap.removeLayer(layer);
          }
        });
        for (const [idx, path] of pathUrls.entries()) {
          const source = new VectorSource({
            format: new GeoJSONFormat(),
            url: path.url,
          });
          const layer = new VectorLayer({
            source,
            projection: 'EPSG:4326',
            style: function (feature) {
              const pathId = feature.get("path_id");
              let color = "#13f016";
              if (pathId == "1") {
                color = "#13f016";
              } else if (pathId != "1") {
                https://www.google.com/maps/@9.0200229,38.7627725,16z?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D
                color = "#1A8F1E";
              }
              return new Style({
                stroke: new Stroke({
                  color: color,
                  width: 6,
                  opacity: 0.6,
                }),
              });
            },
            tile: true,
          });
          if (idx === 0) {
            // Create start point feature
            const feature = new Feature({
              geometry: new Point([
                path.startLocation.coordinates[0],
                path.startLocation.coordinates[1],
              ]),
            });

            // Clear previous start marker
            startMarkerSource.clear(true);
            startMarkerSource.addFeature(feature);

            // Create vector layer for the start marker
            const layer = new VectorLayer({
              source: startMarkerSource,
              projection: 'EPSG:4326',
              style: new Style({
                image: new Icon({
                  scale: 0.6,
                  anchorXUnits: "fraction",
                  anchorYUnits: "fraction",
                  src: "blue.png", // marker icon
                }),
                text: new Text({
                  font: "Normal 16px Arial",
                  //text: `Total Distance is${const2} \n${speed2}`,   // <-- no hardcoded "min"
                   text: `Total Distance ፡ ${const2}`,
                  fill: new Fill({
                    color: "#07490dff", // text color
                  }),
                  stroke: new Stroke({
                    color: "#ffffff", // text outline
                    width: 3,
                  }),
                  backgroundFill: new Fill({
                    color: "#ffffff", // background color behind text
                  }),
                  backgroundStroke: new Stroke({
                    color: "#b8b7b7ff", // border color around background
                    width: 2, // border width
                  }),
                  padding: [3, 6, 3, 6], // top, right, bottom, left padding
                  offsetX: 65, // horizontal offset
                  offsetY: -45, // vertical offset
                }),

              }),
            });

            // Add layer to the map
            window.initialMap.addLayer(layer);
          }
          else {
            const feature = new Feature({
              geometry: new Point(path.startLocation.coordinates),
            });
            const layer = new VectorLayer({
              source: new VectorSource({
                features: [feature],
              }),
              projection: 'EPSG:4326',
              style: new Style({
                image: new CircleStyle({
                  radius: 6,
                  fill: new Fill({
                    color: "#00695c",
                  }),
                }),
                text: new Text({
                  font: "Normal 16px Arial",
                  text: `Tolal${const2} ${speed2}`,
                  fill: new Fill({
                    color: "#fff",
                  }),
                  stroke: new Stroke({
                    color: "#000000",
                    width: 3,
                  }),
                  zIndex: 999999999,
                  offsetX: -45,
                  offsetY: 0,
                  rotation: 0,
                }),
              }),
            });
            window.initialMap.addLayer(layer);
          }
          if (idx === length) {
            const feature = new Feature({
              geometry: new Point([
                path.endLocation.coordinates[0],
                path.endLocation.coordinates[1],
              ]),
            });
            endMarkerSource.clear(true);
            endMarkerSource.addFeature(feature);
            const layer = new VectorLayer({
              source: endMarkerSource,
              projection: 'EPSG:4326',
              style: new Style({
                image: new Icon({
                  scale: 1.4,
                  anchorXUnits: "fraction",
                  anchorYUnits: "fraction",
                  src: "flag.png",
                }),
                
              }),
            });
            window.initialMap.addLayer(layer);
          }
          window.initialMap.addLayer(layer);
        }
        var num = window.initialMap.getLayers().getLength();
        console.log("this is new layers", num);
      }
    }
  }, [props.path_datas, props.activeInnerTab]);

  const handleDirectionClick = useCallback((e) => {
    console.log("hey this is clicked")
    const coordinate = e.coordinate;
    if (startLocationRef.current) {
      const feature = new Feature({
        geometry: new Point(coordinate),
      });
      endMarkerSource.clear(true);
      endMarkerSource.addFeature(feature);

      const layer = new VectorLayer({
        source: endMarkerSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 1.4,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "flag.png",
          }),
        }),
      });
      window.initialMap.addLayer(layer);
      console.log("hey", startLocationRef.current)
      dispatch(
        setLocationStart({
          start: startLocationRef.current,
          end: coordinate,
        })
      );
      startLocationRef.current = null;
    } else {
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      startLocationRef.current = coordinate;
      const feature = new Feature({
        geometry: new Point(coordinate),
      });

      startMarkerSource.clear(true);
      endMarkerSource.clear(true);
      startMarkerSource.addFeature(feature);

      const layer = new VectorLayer({
        source: startMarkerSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 0.6,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",

            src: "blue.png",
          }),
        }),
      });
      window.initialMap.addLayer(layer);
    }
  }, []);


  useEffect(() => {
    const query = queryString.parse(window.location.search, {
      parseNumbers: true,
    });
    if (query.lat && query.lng) {
      const feature = new Feature({
        geometry: new Point([query.lng, query.lat]),
      });
      pickLocationSource.clear(true);
      pickLocationSource.addFeature(feature);
      const layer = new VectorLayer({
        source: pickLocationSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 0.6,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "red.png",
          }),
        }),
      });

      window.initialMap.addLayer(layer);
    }
  }, []);

  useEffect(() => {
    const query = queryString.parse(window.location.search, {
      parseNumbers: true,
    });

    dispatch(
      setSharedLocationStart({
        query,
      })
    );
  }, []);

  useEffect(() => {
    /**
     * Disable browser context menu
     */
    window.initialMap.on("contextmenu", function (e) {
      e.preventDefault();
    });
  }, []);

  return (
    <div>
      <div ref={mapElement} className="map-container"></div>
      
      {/* Loading indicator */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          <Typography variant="h6">Loading map features...</Typography>
        </Box>
      </Backdrop>

      {/* Error notification */}
      <Stack spacing={2} sx={{ width: "100%", position: 'absolute', top: 10, left: 10, zIndex: 1000 }}>
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={() => setError(null)}
        >
          <Alert
            onClose={() => setError(null)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {error}
          </Alert>
        </Snackbar>
      </Stack>
      {/* Interactive Feature Sidebar with Google Maps-like styling */}
      <Drawer
        anchor="left"
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 450,
            padding: 0,
            backgroundColor: '#ffffff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        }}
      >
        <Fade in={sidebarOpen} timeout={300}>
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              p: 3, 
              borderBottom: '1px solid #e0e0e0',
              backgroundColor: '#f8f9fa'
            }}>
              <Typography variant="h5" sx={{ color: '#1a73e8', fontWeight: '700', fontSize: '20px' }}>
                Edas
              </Typography>
              <IconButton 
                onClick={() => setSidebarOpen(false)} 
                size="small"
                sx={{
                  '&:hover': { backgroundColor: '#e8f0fe' },
                  transition: 'background-color 0.2s'
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {selectedFeature ? (
              <>
                {/* Action Buttons */}
                <Box sx={{ 
                  display: 'flex', 
                  gap: 6, 
                  p: 2, 
                  borderBottom: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff'
                }}>
                  <IconButton 
                    onClick={() => navigateToFeature(selectedFeature)}
                    size="small" 
                    title="Navigate to feature"
                    sx={{
                      '&:hover': { backgroundColor: '#e8f0fe', color: '#1a73e8' },
                      transition: 'all 0.2s'
                    }}
                  >
                    <NavigationIcon />
                  </IconButton>
                  <IconButton 
                    onClick={() => toggleFavorite(selectedFeature)}
                    size="small" 
                    title={isFavorite(selectedFeature) ? "Remove from favorites" : "Add to favorites"}
                    color={isFavorite(selectedFeature) ? "warning" : "default"}
                    sx={{
                      '&:hover': { backgroundColor: isFavorite(selectedFeature) ? '#fff3e0' : '#e8f0fe' },
                      transition: 'all 0.2s'
                    }}
                  >
                    <StarIcon />
                  </IconButton>
                  <IconButton 
                    onClick={() => copyFeatureInfo(selectedFeature)}
                    size="small" 
                    title="Copy feature info"
                    sx={{
                      '&:hover': { backgroundColor: '#e8f0fe', color: '#1a73e8' },
                      transition: 'all 0.2s'
                    }}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                  <IconButton 
                    onClick={() => shareFeature(selectedFeature)}
                    size="small" 
                    title="Share feature location"
                    sx={{
                      '&:hover': { backgroundColor: '#e8f0fe', color: '#1a73e8' },
                      transition: 'all 0.2s'
                    }}
                  >
                    <ShareIcon />
                  </IconButton>
                </Box>

                {/* Tabs */}
                <Tabs 
                  value={activeTab} 
                  onChange={handleTabChange} 
                  sx={{ 
                    borderBottom: '1px solid #e0e0e0',
                    '& .MuiTab-root': { 
                      textTransform: 'none', 
                      fontSize: '14px',
                      fontWeight: '500',
                      minHeight: '48px'
                    },
                    '& .Mui-selected': { color: '#1a73e8' },
                    '& .MuiTabs-indicator': { backgroundColor: '#1a73e8' }
                  }}
                >
                  <Tab label="Overview" />
                  <Tab label="History" />
                  <Tab label="Saved" />
                </Tabs>

                {/* Tab Content */}
                <Box sx={{ flex: 1, overflow: 'auto', backgroundColor: '#fafbfc' }}>
                  {activeTab === 0 && (
                    <Box sx={{ p: 3 }}>
                      {/* Feature Type Chip */}
                      <Chip 
                        label={getFeatureType(selectedFeature).toUpperCase()} 
                        size="small" 
                        sx={{ 
                          mb: 3, 
                          backgroundColor: '#e8f0fe',
                          color: '#1a73e8',
                          fontWeight: '600',
                          fontSize: '12px'
                        }}
                      />
                      
                      {/* All Feature Content Combined */}
                      <Box 
                        dangerouslySetInnerHTML={{ 
                          __html: formatPopupContent(selectedFeature). detailContent+ 
                                  (formatPopupContent(selectedFeature).mainContent ? 
                                   `<div style="margin-top: 24px; padding-top: 24px; border-top: 1px solid #e0e0e0;">
                                     ${formatPopupContent(selectedFeature).mainContent}
                                   </div>` : '')
                        }} 
                      />
                    </Box>
                  )}
                  
                  {activeTab === 1 && (
                    <Box sx={{ p: 3 }}>
                      <Typography variant="h6" sx={{ mb: 3, fontSize: '18px', fontWeight: '600', color: '#202124' }}>
                        Recent Places
                      </Typography>
                      {featureHistory.length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {featureHistory.map((feature, index) => (
                            <Grow in key={index} timeout={(index + 1) * 100}>
                              <Paper 
                                elevation={1}
                                sx={{ 
                                  p: 2, 
                                  cursor: 'pointer',
                                  transition: 'all 0.2s',
                                  '&:hover': { 
                                    backgroundColor: '#f8f9fa',
                                    transform: 'translateX(4px)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                  }
                                }}
                                onClick={() => handleFeatureSelect(feature)}
                              >
                                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '16px', mb: 0.5 }}>
                                  {feature.values_.name_eng || feature.values_.name || feature.values_.prcl_code || 'Unknown Feature'}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '12px' }}>
                                  {getFeatureType(feature)}
                                </Typography>
                              </Paper>
                            </Grow>
                          ))}
                        </Box>
                      ) : (
                        <Typography color="textSecondary" sx={{ textAlign: 'center', py: 4, fontSize: '14px' }}>
                          No recent places
                        </Typography>
                      )}
                    </Box>
                  )}
                  
                  {activeTab === 2 && (
                    <Box sx={{ p: 3 }}>
                      <Typography variant="h6" sx={{ mb: 3, fontSize: '18px', fontWeight: '600', color: '#202124' }}>
                        Saved Places
                      </Typography>
                      {favoriteFeatures.length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {favoriteFeatures.map((feature, index) => (
                            <Grow in key={index} timeout={(index + 1) * 100}>
                              <Paper 
                                elevation={1}
                                sx={{ 
                                  p: 2, 
                                  cursor: 'pointer',
                                  transition: 'all 0.2s',
                                  '&:hover': { 
                                    backgroundColor: '#f8f9fa',
                                    transform: 'translateX(4px)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                  }
                                }}
                                onClick={() => handleFeatureSelect(feature)}
                              >
                                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '16px', mb: 0.5 }}>
                                  {feature.values_.name_eng || feature.values_.name || feature.values_.prcl_code || 'Unknown Feature'}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ fontSize: '12px' }}>
                                  {getFeatureType(feature)}
                                </Typography>
                              </Paper>
                            </Grow>
                          ))}
                        </Box>
                      ) : (
                        <Typography color="textSecondary" sx={{ textAlign: 'center', py: 4, fontSize: '14px' }}>
                          No saved places yet
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </>
            ) : (
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                height: '100%', 
                gap: 3,
                backgroundColor: '#fafbfc',
                p: 3
              }}>
                <Box sx={{ textAlign: 'center' }}>
                  <LocationOnIcon sx={{ fontSize: 48, color: '#9e9e9e', mb: 2 }} />
                  <Typography variant="h6" sx={{ color: '#757575', fontSize: '18px', fontWeight: '500' }}>
                    Select a place on the map
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#9e9e9e', fontSize: '14px', mt: 1 }}>
                    Click on any landmark or parcel to see details
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#1a73e8",
                    color: "#ffffff",
                    fontWeight: '500',
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    fontSize: '14px',
                    "&:hover": {
                      backgroundColor: '#1557b0',
                    },
                  }}
                >
                  Add a Place
                </Button>
              </Box>
            )}
          </Box>
        </Fade>
      </Drawer>

      {/* Copy/Share Feedback */}
      <Snackbar
        open={copiedText}
        autoHideDuration={2000}
        onClose={() => setCopiedText(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Copied to clipboard!
        </Alert>
      </Snackbar>

      {pickedLocation ? (
        <ShareLocation pickedLocation={pickedLocation} />
      ) : null}
      {pathUrls.length >= 1 ? <ShareRoute pathUrls={pathUrls} /> : null}

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openRoad}
          autoHideDuration={4000}
          sx={{ paddingLeft: "80%" }}
          onClose={handleCloseRoad}
        >
          <Alert
            onClose={handleCloseRoad}
            severity="success"
            sx={{ width: "100%" }}
          >
            There is no road between those places!
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
};
